module.exports = __webpack_public_path__ + "static/salesforce-logo-0af134b8990e1e7c4e023a3f7b27bd8d.svg";